"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddEthereumChainParameters = exports.switchToChainId = exports.isLoading = exports.createConnection = exports.restoreConnection = exports.fetchChainId = exports.fetchAccounts = exports.getListener = exports.initialState = exports.AuthStatus = exports.AuthEvent = exports.chains = void 0;
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const ConnectionManager_1 = require("decentraland-connect/dist/ConnectionManager");
const chainConfiguration_1 = require("decentraland-dapps/dist/lib/chainConfiguration");
const auth_1 = require("../utils/auth");
const identify_1 = require("../utils/auth/identify");
const storage_1 = require("../utils/auth/storage");
const rollbar_1 = __importDefault(require("../utils/development/rollbar"));
const segment_1 = __importDefault(require("../utils/development/segment"));
const SingletonListener_1 = __importDefault(require("../utils/dom/SingletonListener"));
exports.chains = [
    chain_id_1.ChainId.ETHEREUM_MAINNET,
    chain_id_1.ChainId.ETHEREUM_ROPSTEN,
    chain_id_1.ChainId.ETHEREUM_GOERLI,
    chain_id_1.ChainId.ETHEREUM_KOVAN,
    chain_id_1.ChainId.ETHEREUM_RINKEBY,
    chain_id_1.ChainId.ETHEREUM_SEPOLIA,
    chain_id_1.ChainId.MATIC_MAINNET,
    chain_id_1.ChainId.MATIC_MUMBAI,
];
var AuthEvent;
(function (AuthEvent) {
    AuthEvent["Connect"] = "Connect";
    AuthEvent["Connected"] = "Connected";
    AuthEvent["Disconnected"] = "Disconnected";
})(AuthEvent = exports.AuthEvent || (exports.AuthEvent = {}));
var AuthStatus;
(function (AuthStatus) {
    AuthStatus[AuthStatus["Restoring"] = 0] = "Restoring";
    AuthStatus[AuthStatus["Disconnected"] = 1] = "Disconnected";
    AuthStatus[AuthStatus["Connected"] = 2] = "Connected";
    AuthStatus[AuthStatus["Connecting"] = 3] = "Connecting";
    AuthStatus[AuthStatus["Disconnecting"] = 4] = "Disconnecting";
})(AuthStatus = exports.AuthStatus || (exports.AuthStatus = {}));
exports.initialState = Object.freeze({
    selecting: false,
    account: null,
    identity: null,
    provider: null,
    providerType: null,
    chainId: null,
    error: null,
    status: AuthStatus.Restoring,
});
let WINDOW_LISTENER = null;
function getListener() {
    if (!WINDOW_LISTENER) {
        WINDOW_LISTENER = SingletonListener_1.default.from(window);
    }
    return WINDOW_LISTENER;
}
exports.getListener = getListener;
function fetchAccounts(provider) {
    return __awaiter(this, void 0, void 0, function* () {
        const currentAccounts = (yield provider.request({
            method: 'eth_accounts',
        }));
        if (currentAccounts.length === 0) {
            throw new Error(`Provider is not connected`);
        }
        return currentAccounts.map((account) => account.toLowerCase());
    });
}
exports.fetchAccounts = fetchAccounts;
function fetchChainId(provider) {
    return __awaiter(this, void 0, void 0, function* () {
        const currentChainId = (yield provider.request({
            method: 'eth_chainId',
        }));
        return parseInt(currentChainId, 16);
    });
}
exports.fetchChainId = fetchChainId;
function restoreConnection() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const identity = (0, storage_1.getCurrentIdentity)();
            const connectionData = ConnectionManager_1.connection.getConnectionData();
            // drop identity when connection data is missinig
            if (identity && !connectionData) {
                (0, storage_1.setCurrentIdentity)(null);
            }
            if (identity && connectionData) {
                const data = yield ConnectionManager_1.connection.connect(connectionData.providerType, connectionData.chainId);
                // const previousConnection = await connection.tryPreviousConnection()
                const provider = data.provider;
                if (!provider) {
                    throw new Error(`Error getting provider`);
                }
                const account = yield (0, identify_1.ownerAddress)(identity.authChain);
                const providerType = connectionData.providerType;
                const currentAccounts = yield fetchAccounts(data.provider);
                if (currentAccounts[0] !== account) {
                    throw new Error(`Account changed`);
                }
                const currentChainId = yield fetchChainId(data.provider);
                return {
                    account,
                    provider,
                    chainId: Number(currentChainId),
                    providerType,
                    identity,
                    status: AuthStatus.Connected,
                    selecting: false,
                    error: null,
                };
            }
        }
        catch (err) {
            console.error(err);
            (0, rollbar_1.default)((rollbar) => rollbar.error(err));
            (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: err.message, stack: err.stack })));
            return Object.assign(Object.assign({}, exports.initialState), { status: AuthStatus.Disconnected, error: err.message });
        }
        return Object.assign(Object.assign({}, exports.initialState), { status: AuthStatus.Disconnected });
    });
}
exports.restoreConnection = restoreConnection;
function createConnection(providerType, chainId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            ConnectionManager_1.connection.getConnectionData();
            const data = yield ConnectionManager_1.connection.connect(providerType, chainId);
            const identity = yield (0, auth_1.identify)(data);
            if (identity && identity.authChain) {
                const account = yield (0, identify_1.ownerAddress)(identity.authChain);
                // const previousConnection = await connection.tryPreviousConnection()
                Promise.resolve().then(() => {
                    (0, storage_1.setCurrentIdentity)(identity);
                });
                const currentAccounts = yield fetchAccounts(data.provider);
                if (currentAccounts[0] !== account) {
                    throw new Error(`Account changed`);
                }
                const currentChainId = yield fetchChainId(data.provider);
                return {
                    account,
                    identity,
                    chainId: Number(currentChainId),
                    providerType,
                    status: AuthStatus.Connected,
                    provider: data.provider,
                    selecting: false,
                    error: null,
                };
            }
        }
        catch (err) {
            console.error(err);
            (0, rollbar_1.default)((rollbar) => rollbar.error(err));
            (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: err.message, stack: err.stack })));
            (0, storage_1.setCurrentIdentity)(null);
            return Object.assign(Object.assign({}, exports.initialState), { status: AuthStatus.Disconnected, error: err.message });
        }
        return Object.assign(Object.assign({}, exports.initialState), { status: AuthStatus.Disconnected });
    });
}
exports.createConnection = createConnection;
function isLoading(status) {
    switch (status) {
        case AuthStatus.Connected:
        case AuthStatus.Disconnected:
            return false;
        default:
            return true;
    }
}
exports.isLoading = isLoading;
function switchToChainId(provider, chainId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (provider) {
            try {
                yield provider.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: '0x' + chainId.toString(16) }],
                });
            }
            catch (switchError) {
                if (switchError.code === 4902) {
                    try {
                        yield provider.request({
                            method: 'wallet_addEthereumChain',
                            params: [getAddEthereumChainParameters(chainId)],
                        });
                        const currentChainId = yield fetchChainId(provider);
                        if (currentChainId !== chainId) {
                            throw new Error('chainId did not change after adding network');
                        }
                    }
                    catch (addError) {
                        throw new Error(`Error adding network: ${addError.message}`);
                    }
                }
                else {
                    throw new Error(`Error switching network: ${switchError.message}`);
                }
            }
        }
    });
}
exports.switchToChainId = switchToChainId;
function getAddEthereumChainParameters(chainId) {
    const hexChainId = '0x' + chainId.toString(16);
    const chainName = (0, chain_id_1.getChainName)(chainId);
    const config = (0, chainConfiguration_1.getChainConfiguration)(chainId);
    switch (chainId) {
        case chain_id_1.ChainId.MATIC_MAINNET:
            return {
                chainId: hexChainId,
                chainName,
                nativeCurrency: {
                    name: 'MATIC',
                    symbol: 'MATIC',
                    decimals: 18,
                },
                rpcUrls: ['https://rpc-mainnet.maticvigil.com/'],
                blockExplorerUrls: ['https://polygonscan.com/'],
            };
        case chain_id_1.ChainId.MATIC_MUMBAI:
            return {
                chainId: hexChainId,
                chainName,
                nativeCurrency: {
                    name: 'MATIC',
                    symbol: 'MATIC',
                    decimals: 18,
                },
                rpcUrls: ['https://rpc-mumbai.maticvigil.com/'],
                blockExplorerUrls: ['https://mumbai.polygonscan.com/'],
            };
        case chain_id_1.ChainId.ETHEREUM_MAINNET:
        case chain_id_1.ChainId.ETHEREUM_ROPSTEN:
        case chain_id_1.ChainId.ETHEREUM_RINKEBY:
        case chain_id_1.ChainId.ETHEREUM_KOVAN:
        case chain_id_1.ChainId.ETHEREUM_GOERLI:
        case chain_id_1.ChainId.ETHEREUM_SEPOLIA:
            return {
                chainId: hexChainId,
                chainName,
                nativeCurrency: {
                    name: 'Ether',
                    symbol: 'ETH',
                    decimals: 18,
                },
                rpcUrls: [config.rpcURL],
                blockExplorerUrls: ['https://etherscan.io'],
            };
    }
}
exports.getAddEthereumChainParameters = getAddEthereumChainParameters;
